export default __webpack_public_path__ + "static/media/iconbutton-close-24.d47a93c8.svg";